import React from 'react';
import { RootState } from '@store/store';
import { useSelector } from 'react-redux';
import defaultProfile from "src/assets/images/default_profile_image.png";

const PatientDetail: React.FC = () => {
    const { userDetails } = useSelector((store: RootState) => store.appReducer);
    return (
        <div className="customer-pharmacy-card-left">
            <h2 className='font-Poppins-SemiBold border-b-[1px] border-[#A2A0A0] font-size-18px theme-color-green'>Customer Details</h2>
            <div className='patient-detail-box'>
                <img
                    onError={(e) => {
                        const target = e.target as HTMLImageElement; // Assert the type
                        if (target) {
                            target.src = defaultProfile;
                        }
                    }}
                    src={`${userDetails?.coverPhoto}?t=${Date.now()}`}
                    alt={`${userDetails?.firstName || ""} ${userDetails?.lastName || ""}`}
                    className="patient-image"
                />
                <div>
                    <span className='font-size-16px block text-[#707070] font-Poppins-SemiBold'>Customer</span>
                    <span className='font-size-18px block theme-color-green font-Poppins-SemiBold'>{`${userDetails?.firstName || ""} ${userDetails?.lastName || ""}`}</span>
                </div>
            </div>
        </div>
    );
};

export default PatientDetail;